
import {
  AppstoreOutlined,
  ContainerOutlined,
  DesktopOutlined,
  MailOutlined,
  PieChartOutlined,
} from '@ant-design/icons';
export const hotproducts=[
  {
    name:'Jacket',
    image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkt-vPzUfAoSwqPWC4464GRdNFhTOjQc5_AmTpo7ktTw&s',
    qty:1,
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'1',
    rating:'2',
    
    discount:'25',
    view:'9519',
    stock:'894',
    relatedProduct:[
      {
        name:'sweater',
    image:'https://www.travelandleisure.com/thmb/X7YkPT22zUM8v0xUiz08-DIBmek=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Best-Sweaters-for-Men-TL-tout-36700df70d7a4f438d39fa03442986a0.jpg',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'2',
    rating:'2',
    qty:1,
    
    discount:'25',
    view:'9519',
    stock:'894',
      },{
        name:'Wollen dress ',
        image:'https://media.gq.com/photos/654e5cae905847e9c9e10470/master/pass/winter-essentials.jpg',
        price:60200,
        discription:'warm and best',
        brand:'abfjfc',
        id:'3',
        rating:'4.5',
        discount:'12',
        qty:1,
        
      view:'500',
      stock:'200',
      },
    ]
    
  },

 
  {
    name:'Hoodie',
    image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRcGwBJC16jYr6cv-VlpKeXMQzvgqiYDw70mPj-kqScmg&s',
    price:12000,
    discription:'Best winter Hoodie',
    brand:'fsfs',
    id:'4',
    rating:'5',
    discount:'10',
    qty:1,
    
    view:'3520',
    stock:'50',
    relatedProduct:[
      {
        name:'Jacket',
    image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRc62zOzNHDaBGYJKze3UdEs5IKeUo1u9ldnYeu9TVbwQ&s',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'5',
    rating:'2',
    discount:'25',
   
    qty:1,
    view:'9519',
    stock:'894',
      },
      {
        name:'Jacket',
    image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkt-vPzUfAoSwqPWC4464GRdNFhTOjQc5_AmTpo7ktTw&s',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'6',
    rating:'2',
    qty:1,
    discount:'25',
    view:'9519',
    stock:'894',
      },
      {
        name:'sweater',
    image:'https://www.travelandleisure.com/thmb/X7YkPT22zUM8v0xUiz08-DIBmek=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Best-Sweaters-for-Men-TL-tout-36700df70d7a4f438d39fa03442986a0.jpg',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'7',
    rating:'2',
    qty:1,
    discount:'25',
    view:'9519',
    stock:'894',
      },{
        name:'Wollen dress ',
        image:'https://media.gq.com/photos/654e5cae905847e9c9e10470/master/pass/winter-essentials.jpg',
        price:60200,
        discription:'warm and best',
        brand:'abfjfc',
        id:'8',
        rating:'4.5',
        qty:1,
        discount:'12',
      view:'500',
      stock:'200',
      },
    ]

  },
  {
    name:'T-shirt',
    image:'https://cms.cloudinary.vpsvc.com/images/c_scale,dpr_auto,f_auto,q_auto:good,w_1920/site-merchandising/00f0b527-f041-4cca-aceb-60572ca7686a/en-au/ANZS-tshirt-cat-marquee-001',
    price:4000,
    discription:'best of the best',
    brand:'DVDSF',
    id:'9',
    rating:'2',
    qty:1,
    discount:'20',
    view:'651',
    stock:'516',
    relatedProduct:[
      {
        name:'Jacket',
    image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkt-vPzUfAoSwqPWC4464GRdNFhTOjQc5_AmTpo7ktTw&s',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'10',
    rating:'2',
    qty:1,
    discount:'25',
    view:'9519',
    stock:'894',
      },      {
        name:'sweater',
    image:'https://www.travelandleisure.com/thmb/X7YkPT22zUM8v0xUiz08-DIBmek=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Best-Sweaters-for-Men-TL-tout-36700df70d7a4f438d39fa03442986a0.jpg',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'11',
    rating:'2',
    qty:1,
    discount:'25',
    view:'9519',
    stock:'894',
      }
    ]
  },
  {
    name:'Shoes',
    image:'https://www.azzurrasport.eu/pub/media/catalog/product/cache/0b8817121aedd409f092350af4c5165e/1/5/15815-lacoste-scarpa-uomo-lerond-pro-1r5_01.jpg',
    price:13000,
    discription:' new arrival',
    brand:'Lacoste',
    id:'12',
    rating:'4',
    qty:1,
    discount:'13',
    view:'651',
    stock:'100',
    relatedProduct:[
      {
        name:'Jacket',
    image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkt-vPzUfAoSwqPWC4464GRdNFhTOjQc5_AmTpo7ktTw&s',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'13',
    rating:'2',
    qty:1,
    discount:'25',
    view:'9519',
    stock:'894',
      },
      {
        name:'sweater',
    image:'https://www.travelandleisure.com/thmb/X7YkPT22zUM8v0xUiz08-DIBmek=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Best-Sweaters-for-Men-TL-tout-36700df70d7a4f438d39fa03442986a0.jpg',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'14',
    rating:'2',
    qty:1,
    discount:'25',
    view:'9519',
    stock:'894',
      }
    ]
  },
  

  {
    name:'Wollen dress ',
    image:'https://media.gq.com/photos/654e5cae905847e9c9e10470/master/pass/winter-essentials.jpg',
    price:60200,
    discription:'warm and best',
    brand:'abfjfc',
    id:'15',
    rating:'1',
    qty:1,
    discount:'9',
    view:'565',
    stock:'665',
    relatedProduct:[
      {
        name:'Jacket',
    image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkt-vPzUfAoSwqPWC4464GRdNFhTOjQc5_AmTpo7ktTw&s',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'16',
    rating:'2',
    qty:1,
    discount:'25',
    view:'9519',
    stock:'894',
      },      {
        name:'sweater',
    image:'https://www.travelandleisure.com/thmb/X7YkPT22zUM8v0xUiz08-DIBmek=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/Best-Sweaters-for-Men-TL-tout-36700df70d7a4f438d39fa03442986a0.jpg',
    price:10000,
    discription:'Best for Adult',
    brand:'abc',
    id:'17',
    rating:'2',
    qty:1,
    discount:'25',
    view:'9519',
    stock:'894',
      }
    ]
  },
  

]
  


  export const handiCrafts=[
    {
      name:'Track',
      image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRm3g15QEPY6HZw3R7e67s50GWGstT1z4Rc0kOSymbvww&s',
      price:1200,
      discription:' water proof jacket',
      brand:'abc',
      id:'18',
      rating:'3',
      qty:1,
      discount:'13',
    view:1100,
    stock:'1010',
    },

   
    {
      name:'Hoodie',
      image:'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7pNaGJbiJ_oi_a_Y3WWndrBTf32tUaFwXv2JEAby10g&s',
      price:12000,
      discription:'Best for Adult winter Hoodie',
      brand:'fsfs',
      id:'19',
      rating:'5',
      qty:1,
      discount:'7',
      view:'1100',
      stock:'105',
    },
    {
      name:'T-shirt',
      image:'https://cms.cloudinary.vpsvc.com/images/c_scale,dpr_auto,f_auto,q_auto:good,w_1920/site-merchandising/00f0b527-f041-4cca-aceb-60572ca7686a/en-au/ANZS-tshirt-cat-marquee-001',
      price:4000,
      discription:'best of the best',
      brand:'DVDSF',
      id:'20',
      rating:'5',
      discount:'11',
      qty:1,
      view:'604',
      stock:'150',
    },
    {
      name:'Shoes',
      image:'https://www.azzurrasport.eu/pub/media/catalog/product/cache/0b8817121aedd409f092350af4c5165e/1/5/15815-lacoste-scarpa-uomo-lerond-pro-1r5_01.jpg',
      price:1300,
      discription:'Best arrival',
      brand:'Lacoste',
      id:'21',
      rating:'2.5',
      discount:'8',
      qty:1,
      view:'460',
      stock:'110',
    },
    

    {
      name:'Wollen dress ',
      image:'https://media.gq.com/photos/654e5cae905847e9c9e10470/master/pass/winter-essentials.jpg',
      price:60200,
      discription:'warm and best',
      brand:'abfjfc',
      id:'22',
      rating:'4.5',
      qty:1,
      discount:'12',
    view:'500',
    stock:'200',
    },
    
  
  ]
  export const Payment=[
    {
      name:"Esewa",
      color:"limegreen",
      id:123,
      logo:"https://th.bing.com/th/id/OIP.iJwN4-dPt7UkbndhLEycVAHaD4?rs=1&pid=ImgDetMain"

  },
    {
      name:"Khalti",
      color:"indigo",
      id:1453,
      logo:"https://yt3.ggpht.com/a/AATXAJxlvcOqurtA1Q7IPDbNKICwDmlbkH80bEEbxg=s900-c-k-c0xffffffff-no-rj-mo"

  },
    {
      name:"C.O.D",
      color:"orange",
      id:873,
      logo:"https://th.bing.com/th/id/OIP.DqhsSpVNpCI5VC5BOTpCcQHaEE?rs=1&pid=ImgDetMain",

  },
]
const getItem=(label, key, icon, children, type)=> {
  
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}
export const adminItems = [
  getItem('Dashboard', '/admin/dashboard', <PieChartOutlined />),
  getItem('User List', '/admin/userlist', <DesktopOutlined />),
  getItem('Profile', '/admin/profile', <ContainerOutlined />),
  getItem('Hot Product', '/admin/hotproduct', <MailOutlined />, ),
  getItem('Navigation Two', 'sub2', <AppstoreOutlined />, 
    
   
  ),
];